import React from 'react';

const experience = [
  {
    position: 'Mobile and Web App Developer',
    company: 'Molecular Majik',
    duration: 'Jan 2020 - Present',
    detail: 'Created Full-Stack applications using PHP  & mySQL.  Created mobile applications using NodeJS',
  },
  {
    position: 'Web App Developer',
    company: 'Kush Concepts',
    duration: 'Oct 2018 - Jan 2020',
    detail: 'web development and ecommerce, and created vector graphics for products amd ads.',
  },
  {
    position: 'Web Developer',
    company: 'California Medical Clinic',
    duration: 'may 2014 - Oct 2018',
    detail: 'Full stack PHP & mySQL systems for tracking prescriptions.',
  }
];

const Experience = () => {
  return (
    <div className="timeline" id="experience">
      <div className="timeline-container">

        {experience.map((item, index) => (
          <div key={index} className={`timeline-row ${index%2===0 ? "timeline-left" : "timeline-right" }`}>
            <div className="timeline-content active">
              <h3 className="timeline-heading">{item.position}</h3>
              <p className="timeline-subheading">{item.company}</p>
              <p className="timeline-duration">{item.duration}</p>
              <p className="timeline-detail">{item.detail}</p>
            </div>

            <div className="timeline-content" />
          </div>
        ))}
      </div>
      <div className="timneline-spine"> </div>
    </div>
  );
}

export default Experience;
